module.exports = __webpack_public_path__ + "media/country_flags/no-5948449b.png";